import { createFileRoute, Navigate, redirect } from '@tanstack/react-router';
import { TeamMemberDashboardPage } from '@pages/team-dashboard';
import type { RouterContext } from '@shared/config/router-context';
import { useAbility } from '@features/authorization';

export const Route = createFileRoute('/$locale/_authenticated/team-dashboard')({
  beforeLoad: ({ context, params }) => {
    const { auth, ability } = context as RouterContext;

    if (auth.isLoading || !auth.isAuthenticated) {
      return;
    }

    if (!ability.can('manage', 'all') && !ability.can('read', 'Dashboard')) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({
        to: '/$locale/unauthorized',
        params: { locale: params.locale },
      });
    }
  },
  component: TeamDashboardRoute,
});

function TeamDashboardRoute() {
  const { locale } = Route.useParams();
  const ability = useAbility();

  if (!ability.can('manage', 'all') && !ability.can('read', 'Dashboard')) {
    return <Navigate to="/$locale/unauthorized" params={{ locale }} replace />;
  }

  return <TeamMemberDashboardPage locale={locale} />;
}
